var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "PaymentCancellationModal" }, [
    _c(
      "section",
      { staticClass: "flex justify-content space-between mt-5 pt-5" },
      [
        _c("h3", { staticClass: "form-wrapper-body-title " }, [
          _vm._v("Cancel Registration ")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "PaymentCancellationModal__warning" }, [
          _vm._v(
            "\n      Are you sure you want to cancel your registration? \n      "
          ),
          _vm.isWaitlistCancellation
            ? _c("span", [
                _vm._v("By clicking cancel,"),
                _c("span", { staticStyle: { "font-weight": "600" } }, [
                  _vm._v("your spot in the waitlist will be lost.")
                ])
              ])
            : _c("span", [
                _vm._v("By clicking cancel, "),
                _c("span", { staticStyle: { "font-weight": "600" } }, [
                  _vm._v("your spot in the acticity will be lost.")
                ])
              ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "form-wrapper-footer " }, [
      _c(
        "button",
        {
          class: ["form-wrapper-footer-button", "danger-btn"],
          style: { width: "40%", marginRight: "1rem" },
          on: { click: _vm.cancle }
        },
        [_vm._v("\n        Cancel\n      ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: [
            "form-wrapper-footer-button",
            "primary-btn",
            false && "ie-spinner"
          ],
          style: { width: "40%" },
          on: { click: _vm.back }
        },
        [_vm._v("\n        Back\n      ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fee7f766", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fee7f766","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PaymentCancellationModal.vue
// module id = null
// module chunks = 